import React from 'react';
import PropTypes from 'prop-types';
import BetHistoryItem from './BetHistoryListItem';

import Spinner from '../../common/spinner';

import './styles.scss';


const BetHistoryList = ({ isLoading, currencySign, bets, bookmakerName }) => (
    <div className='MyBetsSingleBetContainer'>
        {/* Repeat bets */}
        {
            bets.map(bet => (
                <BetHistoryItem
                    {...bet}
                    currencySign={currencySign}
                    bookmakerName={bookmakerName}
                    key={`${bet.receiptId}_${bet.timeBetPlaced}`}
                />
            ))
        }

        <Spinner visible={isLoading} className="bs-betHistory__spinner">
            Requesting Bet History data
        </Spinner>
    </div>
);

BetHistoryList.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    bets: PropTypes.arrayOf(PropTypes.shape({
        finished: PropTypes.bool.isRequired,
        betType: PropTypes.string.isRequired,
        receiptId: PropTypes.string.isRequired,
        returns: PropTypes.number,
        stake: PropTypes.number.isRequired,
        totalStake: PropTypes.number.isRequired,
        timeBetPlaced: PropTypes.string.isRequired,
        win: PropTypes.bool,
        selections: PropTypes.arrayOf(PropTypes.shape({
            eachWay: PropTypes.bool.isRequired,
            eventName: PropTypes.string.isRequired,
            odd: PropTypes.string.isRequired,
            selectionName: PropTypes.string.isRequired,
        })),
    })).isRequired,
    bookmakerName: PropTypes.string.isRequired
};

export default BetHistoryList;



// WEBPACK FOOTER //
// /src/js/BetHistory/components/BetHistoryList.jsx